import { useTranslation } from 'react-i18next';
import type { InquiryStatus } from '../types/inquiry';

interface InquiryStatusBadgeProps {
  readonly status: string; // string (not InquiryStatus) — tolerates unknown future statuses gracefully
}

// Record<InquiryStatus, string> enforces exhaustiveness at compile time — adding a new
// InquiryStatus value without updating these tables causes a TS error (Effective TypeScript §28).
const STATUS_STYLES: Record<InquiryStatus, string> = {
  new:     'bg-blue-100 text-blue-700',
  read:    'bg-amber-100 text-amber-700',
  replied: 'bg-green-100 text-green-700',
};

const KNOWN_STATUSES = Object.keys(STATUS_STYLES) as InquiryStatus[];

export const InquiryStatusBadge = ({ status }: InquiryStatusBadgeProps) => {
  const { t } = useTranslation('badges');

  const STATUS_LABELS: Record<InquiryStatus, string> = {
    new:     t('statusNew'),
    read:    t('statusRead'),
    replied: t('statusReplied'),
  };

  const isKnown = KNOWN_STATUSES.includes(status as InquiryStatus);
  const classes = isKnown
    ? STATUS_STYLES[status as InquiryStatus]
    : 'bg-gray-100 text-gray-600';
  const label = isKnown
    ? STATUS_LABELS[status as InquiryStatus]
    : status;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${classes}`}>
      {label}
    </span>
  );
};
